// extracted by mini-css-extract-plugin
var _1 = "container--DcY35";
var _2 = "loading--H2Z8V";
export { _1 as "container", _2 as "loading" }
